export enum MobileEvents {
  CERTIFICATE_PREVIEW_PDF = 'LMS_CERTIFICATE_PREVIEW_PDF',
  CERTIFICATE_DOWNLOAD_PDF = 'LMS_CERTIFICATE_DOWNLOAD_PDF',
  CERTIFICATES_DOWNLOAD_ZIP = 'LMS_CERTIFICATES_DOWNLOAD_ZIP',
}
